import React,{useEffect, useState} from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
  Typography,
} from "@mui/material";
import axios from "axios";
import { BASE_API_URL } from "../utils/constants";
import { useSelector } from "react-redux";
import { toyyyymmdd } from "../utils/formatDate";
import "./CourseMaster.css";


const RecommendedTrainings = () => {

  
    const columns= [
    {id:"1", label:"S No."},
    {id:"2", label:"Training Name"},
    {id:"8", label:"Primary Skill"},
    {id:"10", label:"SSI Bundle"},
    {id:"3", label:"Training Mode"},
    {id:"4", label:"Duration (hrs)"},
    {id:"5", label:"Start Date"},
    {id:"6", label:"End Date"},
    {id:"7", label:"Time"},
    {id:"11", label:"Registration Link"},
  ]; 

  const loggedInUser= useSelector(state=> state.poc.enterpriseID); 
  const [ trainings, setTrainings ]= useState([]);
  const [loading, setLoading]= useState(false);

  const fetchtrainings=async(eid)=>{
    setLoading(true);
    if(!eid) return;
    try{
      const response= await axios.get(`${BASE_API_URL}/bundleSkills/recommended-trainings`, {
      params:{eid},  
      header:{
        Authorization: localStorage.getItem("token")
      }
      });
      setTrainings(response?.data);
    }catch(err){
      console.error("Unable to get recommended trainings ", err);
    }finally{
      setLoading(false);
    }
  
  }

  useEffect(()=>{
    fetchtrainings(loggedInUser);
  },[loggedInUser]);

 const captureInterest = async(id) =>{
  if(!loggedInUser){
    console.error()
  }
  try{
    const response= await axios.post(`${BASE_API_URL}/bundleSkills/capture-interest`,
      {trainingId:id, userId:loggedInUser},{
      headers:{
        Authorization: localStorage.getItem("token")
      }
    }
    ); 
  }catch(err){
    console.error("unable to caprure interest",err);
  }
 }

  return (
    <TableContainer component={Paper} sx={{paddingX:"15px", maxHeight: 440 }} className="courseMasterTable">
      <Typography variant="h6" sx={{ p: 2 }}>
        Recommended Trainings
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={column.align}
                style={{
                  top: 0,
                  minWidth: column.minWidth,
                  color: "#fff",
                  backgroundColor: "#550A69",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {trainings.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.primary_skill}</TableCell>
              <TableCell>{row.ssi_bundle}</TableCell>
              <TableCell>{row.mode?.toUpperCase()}</TableCell>
              <TableCell>{row.duration}</TableCell>
              <TableCell>{toyyyymmdd(row.start_date)}</TableCell>
              <TableCell>{toyyyymmdd(row.end_date)}</TableCell>
              <TableCell>{row.time || "NA"}</TableCell>
              <TableCell>
                {row.registration_link?.includes("http")?
                  <Link
                    href={row.registration_link}
                    target="_blank"
                    rel="noopener"
                    underline="hover"
                    color="primary"
                    onClick={() => captureInterest(row.id)}
                  >
                    Register
                  </Link> :
                  "NA"
                }
                
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RecommendedTrainings;
